export default __webpack_public_path__ + "static/media/schedule-success.cbece9c7.svg";